import React, {ReactNode} from 'react';
import {withGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {DefaultRegistration} from './DefaultRegistration';
import {configStore} from 'app/store/global';
import {observer} from 'mobx-react';

const COUNTRY_TO_REMOVE = ['eu'];

@observer
class FullRegistration extends DefaultRegistration {
    static LEAD_FIELDS = [
        'name',
        'password',
        'email',
        'first_name',
        'last_name'
    ];

    static METHOD = 'full';

    render(): ReactNode {
        return this.state.success
            ? <div>{this.state.success}</div>
            : <form id="full-sign-up" onSubmit={this.signUp} ref={this.rootForm}
                className="form-popup popup-form--error">
                <input name="site_lang" type="hidden" value={configStore.CONFIG?.lang}/>
                <input name="full_registered" type="hidden" value="1"/>
                {[
                    this.rowName(),
                    this.rowPassword(true),
                    this.rowEmailFull(),
                    this.rowPhone(),
                    this.rowFirstName(),
                    this.rowLastName(),
                    this.rowDayOfBirth(),
                    this.rowCountryCode(COUNTRY_TO_REMOVE),
                    this.rowNoMarketingConsent(),
                    this.rowTermsOfUse(),
                    this.rowCaptcha()
                ]}
                <div className="popup-form__submit-row">
                    {this.renderRegisterButton()}
                </div>
            </form>;
    }
}

export default withGoogleReCaptcha(FullRegistration);
